// Generated by GitHub Copilot
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Check, Copy } from 'lucide-react'
import type AuthenticatorAppEnrollment from '#core/entities/auth/mfa/AuthenticatorAppEnrollment.ts'

/** The pending app's secret as text, for an authenticator app that cannot scan the QR code, with a copy button. */
export function AuthenticatorSecret({ enrollment }: { enrollment: AuthenticatorAppEnrollment }) {
  const { t } = useTranslation('settings')
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(enrollment.secret)
      setCopied(true)
    } catch {
      setCopied(false)
    }
  }

  return (
    <div className="input-group mb-3" style={{ maxWidth: '28rem' }}>
      <output className="form-control font-monospace text-break user-select-all" aria-label={t('security.authenticator.setup.secretLabel')}>
        {enrollment.groupedSecret}
      </output>
      <button type="button" className="btn btn-outline-secondary d-inline-flex align-items-center gap-1" onClick={() => void copy()}>
        {copied ? <Check size={16} aria-hidden="true" /> : <Copy size={16} aria-hidden="true" />}
        {t('shared.actions.copy')}
      </button>
      <span className="visually-hidden" role="status">{copied ? t('security.authenticator.setup.copied') : ''}</span>
    </div>
  )
}
